import gql from 'graphql-tag';

import { consultationFragment } from '~/shared/graphql-queries/consultations/index';

export default gql`
  mutation createOneConsultationMutation($record: CreateOneConsultationInput!) {
    createOneConsultationMutation(record: $record) {
      recordId
      record {
        ...ConsultationFragment
      }
      title
      message
    }
  }
  ${consultationFragment}
`;
